import { Appointment } from "@/components/sections/appointment-card"

export const appointments: Appointment[] = [
  {
    section: "Other Concerns",
    title: "Initial Consultation & Treatment",
    frontDescription: "Comprehensive initial consultation for Chinese Medicine and Acupuncture.",
    price: "$165",
    duration: "75mins",
    image: "https://tdjwqdpgnmzhfcqsfyjh.supabase.co/storage/v1/object/sign/images/general/Raintree-Chinese-Medicine-05.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8wYzVlMGM1NS1lYzI2LTRkMTYtOTc2MS1iZDQ1MWJhMGJiYjEiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJpbWFnZXMvZ2VuZXJhbC9SYWludHJlZS1DaGluZXNlLU1lZGljaW5lLTA1LmpwZyIsImlhdCI6MTc2MjMxMzEzNSwiZXhwIjo0ODg0Mzc3MTM1fQ.-a4yfspcBohAswlMUXUvbYLpm0C22QvRGKQdmZdpeAc",
    bookingSource: "homepage_initial_appointment", // Pre-selects General Health + Initial, user picks location → summary
    color: {
      from: "#9ca08f",
      via: "#a8ab9f",
      to: "#b4b7ad"
    },
    backDetails: [
      "Your first appointment, with time to explore your health history, main concerns and goals in detail, followed by an acupuncture treatment. This is the best place to start if you are new to Raintree or returning after a long break.",
      "Please allow 60-75min.",
      "Custom herbal formulas (if prescribed) are not included in the appointment fee.",
    ],
  },
  {
    section: "Other Concerns",
    title: "Return Appointment - Noosa",
    frontDescription: "Standard follow-up appointment for Chinese Medicine and Acupuncture at Raintree Noosa Clinic",
    price: "$120",
    duration: "60mins",
    image: "https://tdjwqdpgnmzhfcqsfyjh.supabase.co/storage/v1/object/sign/images/general/Raintree-Chinese-Medicine-02.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8wYzVlMGM1NS1lYzI2LTRkMTYtOTc2MS1iZDQ1MWJhMGJiYjEiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJpbWFnZXMvZ2VuZXJhbC9SYWludHJlZS1DaGluZXNlLU1lZGljaW5lLTAyLmpwZyIsImlhdCI6MTc2MjMxMzAwNCwiZXhwIjo0ODg0Mzc3MDA0fQ.ljJYG6tYWWP6UFOqkN6we61w3JTr7sdJHPOv7FUC7ds",
    bookingSource: "homepage_noosa_return_appointment", // Pre-selects Noosa + General Health + Return → direct to summary
    color: {
      from: "#8a9080",
      via: "#9ca08f",
      to: "#a8ab9f"
    },
    backDetails: [
      "This appointment includes a review consultation, acupuncture treatment and a review Chinese herbal medicine consultation if desired. Treatment may also include cupping and/or moxa.",
      "Please allow up to 60min.",
      "Herbal medicines (if prescribed) are not included in the appointment fee.",
    ],
  },
  {
    section: "Other Concerns",
    title: "Return Appointment - Maroochydore",
    frontDescription: "Standard follow-up appointment for Chinese Medicine and Acupuncture at Raintree Maroochydore Clinic",
    price: "$130",
    duration: "60mins",
    image: "https://tdjwqdpgnmzhfcqsfyjh.supabase.co/storage/v1/object/sign/images/general/Raintree-Chinese-Medicine-02.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8wYzVlMGM1NS1lYzI2LTRkMTYtOTc2MS1iZDQ1MWJhMGJiYjEiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJpbWFnZXMvZ2VuZXJhbC9SYWludHJlZS1DaGluZXNlLU1lZGljaW5lLTAyLmpwZyIsImlhdCI6MTc2MjMxMzAwNCwiZXhwIjo0ODg0Mzc3MDA0fQ.ljJYG6tYWWP6UFOqkN6we61w3JTr7sdJHPOv7FUC7ds",
    bookingSource: "homepage_maroochydore_return_appointment", // Pre-selects Maroochydore + General Health + Return → direct to summary
    color: {
      from: "#8a9080",
      via: "#9ca08f",
      to: "#a8ab9f"
    },
    backDetails: [
      "This appointment includes a review consultation, acupuncture treatment and a review Chinese herbal medicine consultation if desired. Treatment may also include cupping and/or moxa.",
      "Please allow up to 60min.",
      "Herbal medicines (if prescribed) are not included in the appointment fee.",
    ],
  },
  {
    section: "Other Concerns",
    title: "Extended Appointment",
    frontDescription: "Extended Chinese Medicine and Acupuncture appointment.",
    price: "$220",
    duration: "90mins",
    image: "https://tdjwqdpgnmzhfcqsfyjh.supabase.co/storage/v1/object/sign/images/general/Raintree-Chinese-Medicine-03.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8wYzVlMGM1NS1lYzI2LTRkMTYtOTc2MS1iZDQ1MWJhMGJiYjEiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJpbWFnZXMvZ2VuZXJhbC9SYWludHJlZS1DaGluZXNlLU1lZGljaW5lLTAzLmpwZyIsImlhdCI6MTc2MjMxMzA3MCwiZXhwIjo0ODg0Mzc3MDcwfQ.ixhXHYpVQTGXxZeOsmXciAvtDCOHT53xurfRkdXKLbE",
    bookingSource: "homepage_extended_appointment", // Pre-selects General Health + Extended, user picks location → summary
    color: {
      from: "#7a8070",
      via: "#8a9080",
      to: "#9ca08f"
    },
    backDetails: [
      "Your 90-minute appointment includes a comprehensive health checkup, acupuncture treatment and may include Chinese herbal medicine consultation, cupping therapy, moxa, massage or extended dietary or lifestyle advice.",
      "This appointment is useful for patients with a complex health history or those who know they like more time on the table.",
      "Herbal medicines (if prescribed) are not included in the appointment fee.",
    ],
  },
  {
    section: "Other Concerns",
    title: "Free 15min Phone Consult",
    frontDescription: "A brief phone consultation to discuss your needs and see if Chinese Medicine and acupuncture feel right for you.",
    price: "Free",
    duration: "15mins",
    image: "https://tdjwqdpgnmzhfcqsfyjh.supabase.co/storage/v1/object/sign/images/general/Raintree-Chinese-Medicine-05.jpg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8wYzVlMGM1NS1lYzI2LTRkMTYtOTc2MS1iZDQ1MWJhMGJiYjEiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJpbWFnZXMvZ2VuZXJhbC9SYWludHJlZS1DaGluZXNlLU1lZGljaW5lLTA1LmpwZyIsImlhdCI6MTc2MjMxMzEzNSwiZXhwIjo0ODg0Mzc3MTM1fQ.-a4yfspcBohAswlMUXUvbYLpm0C22QvRGKQdmZdpeAc",
    bookingSource: "homepage_free_consult", // Triggers phone consultation flow directly
    color: {
      from: "#6a7060",
      via: "#7a8070",
      to: "#8a9080"
    },
    backDetails: [
      "A brief phone consultation to discuss your needs and see if Chinese Medicine and acupuncture feel right for you.",
      "This is a great way to get a sense of Renee's approach and ask any questions before booking your first appointment.",
    ],
  },
]

// Helper function to get Other Concerns appointments only
export const getGeneralHealthAppointments = () => {
  return appointments.filter(appt => appt.section === "Other Concerns")
}

